export default "__VITE_ASSET__Dmxcim28__"